var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6a7ef633b5b1d0c7746fb95c5dfe36881f71afc9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["breeze@otovo"]={id:"6a7ef633b5b1d0c7746fb95c5dfe36881f71afc9"};
      